import type { ReadingTime } from '../lib/sanity/types'

export const formatReadingTime = (readingTime?: ReadingTime | null): string => {
  if (!readingTime || !readingTime.value) {
    return ''
  }
  
  return `${readingTime.value} ${readingTime.unit}`
}

export default formatReadingTime

